import { Editor } from 'tinymce'

export const toggleEditableBlocks = (editor: Editor) => {
  const dataAttributes = [
    'data-template-item',
    'data-template',
    'data-case-detail',
    'data-case-detail-table',
  ]

  // Temporarily remove the noneditable class before any content mutation
  const unlockNonEditableBlocks = () => {
    const $ = editor.editorManager.$
    const nonEditableClass = editor.getParam(
      'noneditable_noneditable_class',
      'mceNonEditable',
    )
    $(editor.getBody())
      .find(`*.${nonEditableClass}`)
      .each(function (this: HTMLElement) {
        $(this).removeClass(nonEditableClass)
        $(this).attr('contenteditable', true) // Temporarily allow editing
      })
  }

  // Re-lock non-editable elements after content mutation is finished
  const lockNonEditableBlocks = () => {
    const $ = editor.editorManager.$
    const nonEditableClass = editor.getParam(
      'noneditable_noneditable_class',
      'mceNonEditable',
    )
    $(editor.getBody())
      .find(`*[data-case-detail], *[data-template], *[data-template-item]`)
      .each(function (this: HTMLElement) {
        $(this).addClass(nonEditableClass)
        $(this).attr('contenteditable', false) // Restore non-editable state
      })
  }

  const removeDataAttributes = () => {
    const $ = editor.editorManager.$
    $(editor.getBody())
      .find('*')
      .each(function (this: HTMLElement) {
        dataAttributes.forEach((attr) => {
          if ($(this).attr(attr) !== undefined) {
            $(this).removeAttr(attr)
          }
        })
      })
  }

  return {
    unlockNonEditableBlocks,
    lockNonEditableBlocks,
    removeDataAttributes,
  }
}
